export class AdminRouteUrls {
  public static readonly ADMIN = 'admin';
  public static readonly APPLICATION = 'application';
  public static readonly CONTACTS = 'contacts';
  public static readonly DEFINITIONS = 'definitions';
  public static readonly PERFORMANCE = 'performance';
  public static readonly POIS = 'pois';
}
